import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';


import Toast from 'components/Toast';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

const leadingZero = (number) => `0${number}`.slice(-2);

export default class FlipBoard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leftNumber: 0,
      rightNumber: 0,
      currentNumber: null,
      answerStyle: false,
      toastContent: null,
      headerImage: '',
    };
  }

  componentDidMount() {
    this.matchStep();
    this.setHeader();
  }

  componentDidUpdate(prevProps) {
    const { quizMode, quizTimerExpired, error } = this.props;
    if (quizMode && quizTimerExpired && !prevProps.quizTimerExpired) {
      setTimeout(() => error(true), 600);
    }
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  getCurrentNumber(parsed) {
    const { leftNumber, rightNumber } = this.state;
    if (parsed) {
      return parseInt(`${leftNumber}${rightNumber}`, 10);
    }
    return `${leftNumber}${rightNumber}`;
  }

  matchStep(e) {
    const { steps } = this.props;
    const { currentNumber } = this.state;

    if (steps !== undefined && currentNumber === null) {
      const leftNumber = leadingZero(steps[0])[0];
      const rightNumber = leadingZero(steps[0])[1];
      this.setState({
        leftNumber,
        rightNumber,
        currentNumber: 0,
      });
      return true;
    }

    if (e !== undefined && e.target.id === 'plus' && steps !== undefined && currentNumber < steps.length - 1) {
      this.setState({
        currentNumber: currentNumber + 1,
        leftNumber: leadingZero(steps[currentNumber + 1])[0],
        rightNumber: leadingZero(steps[currentNumber + 1])[1],
      });
      return true;
    }

    if (e !== undefined && e.target.id === 'minus' && steps !== undefined && currentNumber > 0) {
      this.setState({
        currentNumber: currentNumber - 1,
        leftNumber: leadingZero(steps[currentNumber - 1])[0],
        rightNumber: leadingZero(steps[currentNumber - 1])[1],
      });
      return true;
    }

    return false;
  }

  checkAnswer() {
    const { correctAnswer, contentComplete, correctAnswerText, error } = this.props;

    if (correctAnswer === `${this.getCurrentNumber(true)}`) {
      contentComplete();
      this.setState({
        answerStyle: true,
        toastContent: {
          position: 'top-center',
          content: correctAnswerText,
        },
      });
    } else {
      error(true);
    }
  }

  render() {
    const { leftNumber, rightNumber, toastContent, headerImage, answerStyle } = this.state;
    const { question, disableHeader, error, disableToast, completedBefore, correct, correctAnswer, quizMode, quizTimerExpired } = this.props;

    const isLocked = completedBefore || quizTimerExpired;

    // If completedBefore, show correct answer; otherwise show current state
    const correctDigits = (correctAnswer || '').toString().padStart(2, '0');
    const displayLeft = completedBefore ? correctDigits[0] : leftNumber;
    const displayRight = completedBefore ? correctDigits[1] : rightNumber;
    const displayAnswerStyle = completedBefore || answerStyle;

    return (
      <div
        className={clsx('container__question', { 'quiz-mode-card': quizMode })}
        style={{
          pointerEvents: isLocked ? 'none' : 'auto',
        }}
      >
        {!disableHeader && (
          <div className="container__question--image" style={{ backgroundImage: `url(${headerImage})` }} />
        )}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="flipBoard__container">
            <div className="flipBoard">
              <button
                id="plus"
                onClick={(e) => {
                  this.matchStep(e);
                }}
                className="flipButton plus"
              />
              <button
                id="minus"
                onClick={(e) => {
                  this.matchStep(e);
                }}
                className="flipButton minus"
              />
            </div>
            <div className="flipNumbers">
              <div className="number left">{displayLeft}</div>
              <div className="number right">{displayRight}</div>
            </div>
          </div>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {!isLocked && (
            <button
              onClick={() => {
                this.checkAnswer();
              }}
              style={displayAnswerStyle ? { backgroundColor: '#6cd488' } : null}
            >
              {'Submit'}
            </button>
          )}
        </div>
        {error(false)}
        {correct(false)}
      </div>
    );
  }
}

FlipBoard.propTypes = {
  contentComplete: PropTypes.func.isRequired,
  correct: PropTypes.func,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.number),
  completedBefore: PropTypes.bool,
  quizMode: PropTypes.bool,
  quizTimerExpired: PropTypes.bool,
};

FlipBoard.defaultProps = {
  correct: () => {},
  correctAnswerText: '',
  disableHeader: false,
  disableToast: false,
  error: () => {},
  incorrectAnswerText: '',
  steps: [],
  completedBefore: false,
  quizMode: false,
  quizTimerExpired: false,
};
